export default "2dff4800783f4a2b.svg"